import { AbstractDtoService, type GetAllRequestParameters, UNKNOWN_ITEM } from '@pct-ng/core/dto';
import {
  type ForbiddenNicknameGetDTO,
  type ForbiddenNicknameOrderByColumn,
  type ForbiddenNicknamePostDTO,
  ForbiddenNicknameService,
} from '@cappus/sdk-mecap-backend';
import { Injectable } from '@angular/core';
import type { HttpContext } from '@angular/common/http';
import { type Observable } from 'rxjs';
import type { ListPaginatedDTO } from '@pct-sdk/core';
import type { OrderColumn } from '@pct-ng/feature-table-material';
import type { ForbiddenNicknameFiltersToBackend } from './forbidden-nickname-filter';
import { isNil } from '@pct-ts/typeguard';

@Injectable()
export class ForbiddenNicknameDtoService extends AbstractDtoService<
  ForbiddenNicknameService,
  ForbiddenNicknamePostDTO,
  any,
  ForbiddenNicknameGetDTO,
  'id'
> {
  constructor() {
    super({ sort: 'value', direction: 'ASC' }, ForbiddenNicknameService);
  }

  override create(nickname: ForbiddenNicknamePostDTO): Observable<ForbiddenNicknameGetDTO> {
    return this.service.createForbiddenNickname(nickname);
  }

  override update(): Observable<never> {
    throw new Error('ForbiddenNickname update not supported.');
  }

  override delete(id: ForbiddenNicknameGetDTO['id']): Observable<void> {
    return this.service.deleteForbiddenNickname(id);
  }

  override getById(_id: number, _httpContext?: HttpContext): Observable<never> {
    throw new Error('ForbiddenNickname get by id not supported.');
  }

  override getByIds(_ids: number[], _httpContext?: HttpContext): Observable<never[]> {
    throw new Error('ForbiddenNickname get by id not supported.');
  }

  override getAll(
    {
      parameters,
      sort,
      pagination,
    }: GetAllRequestParameters<
      ForbiddenNicknameFiltersToBackend,
      OrderColumn<ForbiddenNicknameOrderByColumn>
    >,
    httpContext?: HttpContext,
  ): Observable<ListPaginatedDTO<ForbiddenNicknameGetDTO>> {
    return this.service.listForbiddenNicknames(
      parameters?.ids,
      parameters?.searchText,
      sort?.field,
      sort?.order,
      pagination?.page,
      pagination?.size,
      httpContext,
    );
  }

  override getDtoId(dto: ForbiddenNicknameGetDTO): ForbiddenNicknameGetDTO['id'];
  override getDtoId(dto: ForbiddenNicknameGetDTO): ForbiddenNicknameGetDTO['id'];
  override getDtoId(
    dto: Partial<ForbiddenNicknameGetDTO> | null | undefined,
  ): ForbiddenNicknameGetDTO['id'] | null | undefined;
  override getDtoId(
    dto: ForbiddenNicknameGetDTO | Partial<never> | null | undefined,
  ): ForbiddenNicknameGetDTO['id'] | null | undefined {
    if (isNil(dto)) {
      return dto;
    }
    return dto.id;
  }

  override toString(dto: ForbiddenNicknameGetDTO): string {
    return dto.value ?? UNKNOWN_ITEM;
  }
}
